import * as React from 'react';
require('./style.css');

interface IProps {
	text: string;
	onClick?: (e: React.MouseEvent<HTMLElement>) => void;
	horizontal?: boolean;
	variant?: 'orange' | 'green';
	size?: 'M' | 'S';
}
/**
 *
 * @param props
 */
export const CardItemBadge = (props: IProps) => {
	const { text, onClick, horizontal, variant, size } = props;
	const onItemClick = (e: React.MouseEvent<HTMLElement>) => {
		if (onClick) {
			onClick(e);
		}
	};

	const className =
		'itemCardBadge ' + (horizontal ? 'horizontal' : 'vertical') + ' ' + (variant || 'green') + ' size-' + (size || 'M');
	return (
		<div className={className} onClick={onItemClick}>
			<div>{text}</div>
		</div>
	);
};
